import React from "react";
import { useDroppable } from "@dnd-kit/core";
import { useSortable, SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import FieldCard from "./FieldCard";

export default function SectionCard({
  section,
  selectedField,
  onSelectField,
  onSelectSection,
  onUpdateSectionTitle,
  onRemoveSection,
}) {
  const sectionSortableId = `section:${section.id}`;
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: sectionSortableId,
  });

  const { setNodeRef: setDropRef, isOver } = useDroppable({ id: `drop-section:${section.id}` });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.7 : 1,
  };

  const fieldIds = (section.fields || []).map((field) => `field:${section.id}:${field.id}`);

  return (
    <article
      ref={setNodeRef}
      style={style}
      className={`rounded-xl border bg-white p-3 ${isOver ? "border-blue-400" : "border-gray-200"}`}
      onClick={() => onSelectSection(section.id)}
    >
      <div className="mb-3 flex items-center gap-2">
        <button
          type="button"
          className="cursor-grab rounded border border-gray-300 px-2 py-1 text-xs text-gray-600"
          {...attributes}
          {...listeners}
        >
          Sleep
        </button>

        <input
          value={section.title}
          onChange={(event) => onUpdateSectionTitle(section.id, event.target.value)}
          className="flex-1 rounded border border-gray-300 px-2 py-1 text-sm"
          placeholder="Sectietitel"
        />

        <button
          type="button"
          onClick={(event) => {
            event.stopPropagation();
            onRemoveSection(section.id);
          }}
          className="rounded border border-red-200 px-2 py-1 text-xs text-red-700 hover:bg-red-50"
        >
          Verwijder
        </button>
      </div>

      <div ref={setDropRef} className="space-y-2 rounded-lg bg-gray-50 p-2">
        <SortableContext items={fieldIds} strategy={verticalListSortingStrategy}>
          {(section.fields || []).map((field) => (
            <FieldCard
              key={field.id}
              sectionId={section.id}
              field={field}
              selected={selectedField?.sectionId === section.id && selectedField?.fieldId === field.id}
              onSelect={() => onSelectField(section.id, field.id)}
            />
          ))}
        </SortableContext>

        {(section.fields || []).length === 0 && (
          <p className="rounded border border-dashed border-gray-300 bg-white px-3 py-4 text-center text-xs text-gray-500">
            Sleep een veldtype hierheen
          </p>
        )}
      </div>
    </article>
  );
}
